import React, { useContext, useState } from "react";
import Navbar from "../../../../common/layout/Navbar";
import {
  empType,
  LicenseTypes,
  PageFor,
  PageFrom,
} from "../../../../../utils/Enum.types";
import List from "./List";
import Table, { ItemDetailsTableFor } from "./Table";
import { AppProvider } from "../../maps/context/context";
import { Tab, Tabs } from "@mui/material";
import { a11yProps, TabPanel } from "../../../../../styles/Tabs";
import AssetSummaryTable from "./AssetSummaryTable";
import { AppContext } from "../../../../../context/context";

interface Props {
  pageFrom: PageFrom;
}

const ReportsIndex = ({ pageFrom }: Props) => {
  const [value, setValue] = useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const { state } = useContext(AppContext);

  const showNavbar =
    state.empSubType === empType.JCP ||
    state.empSubType === empType.PMU ||
    state.empSubType === empType.VENDOR_MANAGER ||
    state.empSubType === empType.HELP_DESK;
  return (
    <AppProvider>
      {pageFrom === PageFrom.GEOENABLED ? (
        <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />
      ) : showNavbar ? (
        <Navbar NavType={LicenseTypes.DASHBOARD} />
      ) : (
        <Navbar NavType={LicenseTypes.COMPANY} />
      )}
      <div className="asset-reports">
        <div className="asset-reports__left">
          <List pageFrom={pageFrom} />
        </div>
        <div className="asset-reports__right">
          <div className="asset-reports__right--tabs">
            <Tabs value={value} onChange={handleChange}>
              <Tab value={0} {...a11yProps(0)} label="Assets" />
              <Tab value={1} {...a11yProps(1)} label="Summary" />
            </Tabs>
          </div>
          <div className="asset-reports__right--tabpanel">
            <TabPanel value={value} index={0}>
              <Table
                pageType={ItemDetailsTableFor.ASSET_WISE}
                type={PageFor.GENERAL}
                pageFrom={pageFrom}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <AssetSummaryTable />
            </TabPanel>
          </div>
        </div>
      </div>
    </AppProvider>
  );
};

export default ReportsIndex;
